import { useTranslation } from "react-i18next";
import checkIcon from "../icons/check.svg";
import CloseIcon from "../icons/x.svg";


const MarkPaidPopup = ({ open, onConfirm, onCancel }) => {
  const { t } = useTranslation();
  if (!open) return null;

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-[1050]">
      <div className="relative w-[674px] h-[376px] bg-white shadow-[0px_20px_80px_#00000011] rounded-[12px] px-6 py-8">
        {/* Close Button */}
        <button
          className="absolute top-4 right-4 w-8 h-8 bg-white flex items-center justify-center rounded-full "
          onClick={onCancel}
        >
          <img src={CloseIcon} alt="Close" />
        </button>
        {/* Icon Section */}
        <div className="flex justify-center mb-6">
          <div className="w-28 h-28 bg-[#6B78F8] rounded-full flex items-center justify-center">
            <img src={checkIcon} alt="Icon" className="w-20 h-16" />
          </div>
        </div>

        {/* Message Section */}
        <div className="text-center py-4 px-12 text-[#36495C] font-semibold text-[20px]" style={{ fontFamily: "Montserrat" }}>
          <p>{t("placeholder.markPaid")}</p>
        </div>

        {/* Button Section */}
        <div className="flex justify-center gap-4 mt-5">
          <button
            onClick={() => onConfirm("ERROR")}
            className="w-[40%] py-2 px-4 rounded-[12px] bg-[#EF476F] text-white text-[18px] font-semibold shadow-[0px_4px_10px_#BEBEBE50] hover:opacity-80"
          >
            {t("placeholder.error")}
          </button>
          <button
            onClick={() => onConfirm("REVERSEMENT")}
            className="w-[40%] py-2 px-4 rounded-[12px] bg-[#6B78F8] text-white text-[18px] font-semibold shadow-[0px_4px_10px_#BEBEBE50] hover:opacity-80"
          >
            {t("placeholder.bank")}
          </button>
        </div>
      </div>
    </div>
  );
};

export default MarkPaidPopup;
